import { Fragment } from 'react';

export function DiscountsAndSpecialOfferings() {
  return (
    <Fragment>
      We may offer discounts to specific groups of Users, such as academic users, and any User claiming the discount may be required to provide further identification and verification for the use of such discount.
      <br /><br />
      We are under no obligation to offer discounts or special prices or special packages to any User and equally, we may terminate or revoke any such discounts at our discretion, at any time.
    </Fragment>
  );
}


export default DiscountsAndSpecialOfferings;
